module.exports = new __parcel__URL__("open-hihat_11.0bc90e96.mp3").toString();